let public_key =`-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyWfZsR82kVtdEkilv7iu
j1wOiRZdFkqOnO3vwCVO77+C1CqXsHJ4RChz/rdAcFvuQRHIfaSJYWuVuRugg4Yj
rctfu4ILuDXPrfmB2N89IWtK6dllELN9/v8qsMCQebd9YJIWojVcV5fvdRPlfyoG
IU785UYp44PAMn8THUdJ3pRILq/IstM6wDe+MbLAStYHX9Hhf/t248JDRyag0wAW
9Jm9uKApLEILsPVIt1tv17TxMxijuXBdjSPoWlB61prM7E7dHOfrhwr6Uq/I9JQ5
BwEgO+e0EIOfsmmTzO7tFTg0CP7Wgt/t1UB6c742/LWjO5LErFBm3DeNCjH82E/h
sQIDAQAB
-----END PUBLIC KEY-----`


let private_key =`not used`


export {public_key, private_key}